import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'

export default class VacancyTopRegionModel extends BaseModel {
  static override constructorName = 'VacancyTopRegionModel'

  name: string = ''
  slug: string = ''
  'name_gde': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(VacancyTopRegionModel)
